import { TableCell } from "@mui/material";
import { OrderSearchOut } from "@providers/hop-ord-server/api";
import { AssignedToSelect, useAssignedToSelect } from "@components";

interface Props {
  order: OrderSearchOut;
  setRowIsHovered?: (v: boolean) => void;
  readOnly?: boolean;
}

const AssignedToCell = ({ order, setRowIsHovered, readOnly }: Props) => {
  const {
    isEditing,
    assignedTo,
    isUnassigned,
    options,
    handleOpen,
    handleClose,
    handleChange,
  } = useAssignedToSelect({
    orderId: order.id,
    assignedDosimetrist: order?.assignedDosimetrist,
    assignablePlanners: order?.assignablePlanners,
  });

  return (
    <TableCell
      onClick={(e) => isEditing && e.stopPropagation()}
      sx={{ minWidth: "220px", maxWidth: "220px" }}
    >
      <AssignedToSelect
        isEditing={isEditing}
        assignedTo={assignedTo}
        isUnassigned={isUnassigned}
        options={options}
        onOpen={handleOpen}
        onClose={handleClose}
        onChange={handleChange}
        readOnly={readOnly}
        label="Assign to"
        onMouseEnter={readOnly ? undefined : () => setRowIsHovered?.(false)}
        onMouseLeave={readOnly ? undefined : () => setRowIsHovered?.(true)}
      />
    </TableCell>
  );
};

export default AssignedToCell;
